import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import styled from 'styled-components'
import { Link } from 'gatsby'

import Angle from '../../atoms/Angle'
import { MysqlCategories } from '../../graphqlTypes'

const Container = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.palette.border.light};
  &:last-child {
    border-width: 0;
  }
`

const ItemLink = styled(Link)<{ large: number | null }>`
  align-items: center;
  display: flex;
  padding: ${({ large }) => (large ? '10px 0 10px 10px' : '5px 0 5px 10px')};
  position: relative;
  text-decoration: none;
`

const Icon = styled.img`
  margin-right: 10px;
  width: 24px;
  height: 24px;
  object-fit: contain;
  vertical-align: middle;
`

const Title = styled.span`
  color: ${({ theme }) => theme.palette.font.link};
  flex: 1;
  font-size: 12px;
  font-weight: 600;
`

const ItemAngle = styled(Angle)`
  width: 24px;
  height: 24px;
  margin-right: auto;
`

type Props = {
  category: MysqlCategories
  className?: string
  large?: boolean
  to: string
}

export default function Item({ className, category, large, to }: Props) {
  return (
    <Container className={className}>
      <ItemLink large={large ? 1 : null} to={to}>
        <LazyLoadComponent>
          <Icon alt={`${category.title}部門 受賞商品`} src={`${category.fields!.imageUrl}?auto=format&w=24&h=24`} />
        </LazyLoadComponent>
        <Title>{category.title}</Title>
        <ItemAngle color="gray" direction="right" />
      </ItemLink>
    </Container>
  )
}
